(function () {

    "use strict";

    angular
        .module('components')
        .component('hEmojiList', {
            controller: HEmojiListComponent,
            controllerAs: '$ctrl',
            bindings: {
                onEmojiSelected: '&'
            },
            templateUrl: '../hmodules/components/h-emojis/h-emoji-list/h-emoji-list.component.ng.html'
        });

    HEmojiListComponent.$inject = ['$scope'];

    function HEmojiListComponent($scope) {

        var self = this;
        self.Emojis = [];
        self.searchResults = [];
        self.searchText = '';

        self.$onInit = function () {
            self.emojis = EMOJIS;
        };

        self.searchEmoji = function () {
            self.searchResults = [];
            if (self.searchText.length === 0) {
                return;
            }
            self.searchText = self.searchText.toLowerCase();
            for (var i in EMOJIS) {
                for (var j in EMOJIS[i].groupEmojis) {
                    if (EMOJIS[i].groupEmojis[j].unicodeName.indexOf(self.searchText) > -1) {
                        self.searchResults.push(EMOJIS[i].groupEmojis[j]);
                    }
                }
            }
            self.viewTrigger =! self.viewTrigger;
        };

        self.assignHandlers = function (element) {
            element.find(".emoji").on("click", function () {
                var clickedElm = $(this);
                var emojiCode = clickedElm.data("emoji-code");
                self.onEmojiSelected({emojiCode:emojiCode});
                self.viewTrigger = !self.viewTrigger;
                $scope.$digest();
            });
        };
    }
})();
